/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useCommonInits } from 'hooks/useCommonInits';
import {
    Typography,
    TextField,
    Modal,
    Backdrop,
    Box,
    Grid,
} from '@mui/material';
import { AppButton } from 'app/components/shared/AppButton';
import {
    updateControlPassword,
    updateUserPassword,
} from 'redux/datasource/dataSourceActions';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { generateHash } from 'utils/encryptDecrypt';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.default',
    border: '1px solid',
    boxShadow: 24,
    p: 2,
};

export default function PasswordModal({
    isOpen,
    handleCloseModal,
    handlePasswordChange,
    flag, changeEmail
}) {
    const { dispatch } = useCommonInits();
    const [confirmPass, setConfirmPass] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        handlePasswordChange;
    }, []);

    const saveNewPassword = () => {
        if (confirmPass.length === 0) {
            setError(true);
        } else if(!flag) {
            const params = {
                email: changeEmail,
                password: generateHash(confirmPass),
            };
            dispatch(updateUserPassword(params));
            handleClose();
        } else if(flag){
            const params = {
                email: changeEmail,
                control_password: generateHash(confirmPass),
            };
            dispatch(updateControlPassword(params));
            handleClose();
        }
    };

    const handleClose = () => {
        handleCloseModal();
    };

    const renderRequest = () => (
            <>
                { !flag ? <Typography variant="h5" style={{ marginBottom: 10 }}>
                    Change Password
                </Typography> : <Typography variant="h5" style={{ marginBottom: 10 }}>
                    Change Control Password
                </Typography>}

                <TextField
                    hiddenLabel
                    required
                    value={changeEmail}
                    fullWidth
                    type={'text'}
                    variant="outlined"
                    size="small"
                    sx={{ marginBottom: '15px' }}
                    label={'Email'}
                    disabled
                />

                <TextField
                    required
                    hiddenLabel
                    fullWidth
                    type={'password'}
                    value={confirmPass}
                    variant="outlined"
                    size="small"
                    label={'New Password'}
                    onChange={e => setConfirmPass(e.target.value)}
                />

                {error ? (
                    <label
                        style={{
                            color: 'red',
                            fontSize: 20,
                            marginBottom: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        All fields are required
                    </label>
                ) : (
                    ''
                )}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: '20px',
                    }}
                >
                    <AppButton variant={'outlined'} action={handleClose}>
                        Cancel
                    </AppButton>{' '}
                    &nbsp; &nbsp; &nbsp;
                    <AppButton
                        variant={'outlined'}
                        action={saveNewPassword}
                    >
                        Change
                    </AppButton>
                </div>
            </>
        );

    return (
        <div>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={isOpen}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid
                            item
                            sx={{
                                position: 'absolute',
                                right: '5px',
                                top: '5px',
                            }}
                        >
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    {renderRequest()}
                </Box>
            </Modal>
        </div>
    );
}
